/****
 * Sets up the Priority Plus navigation pattern
 * Inspired by the Priority Plus + Alt pattern
 * https://bradfrost.github.io/this-is-responsive/patterns.html
 ***/
define([
	'jquery',
	'pubsub',
	'shared.main.screen'
	], function($,pubsub,screenSize) {

    var DEBUG = false;
	var PLUGIN_IDENTIFIER = "mainNav";
	var mainNav;

	(function(){

		mainNav = {
			defaults: {
				el: ".topnav-mainnav",
				dataAttr: "mainnav-options",
				moreSelector: "> li.more",
				moreMenuSelector: ".topnav-mainnav-more-menu",
				menuItemsSelector: "> li:not(.more)",
				utilityNav: ".topnav-utility",
				hideTextClass: "hide-text",
				excludeBreakpoints: ["small"],
				hasChildrenClassName: "has-children"
			},

			/**
			 * Initialize plugin
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				// Cache the various selectors
				self.$moreL1 = $(self.config.moreSelector,self.$element); // The L1 entry for the More menu
				self.$moreMenu = $(self.config.moreMenuSelector,self.$element); // The more menu
				self.$utilityNav = $(self.config.utilityNav);

				self.events();

				if(self._getScreenSize() === "large") {
					self.updateUtilityDisplay();
				}

				self.deferred.resolve();

				// Return self to allow for JQuery-style chaining
				return self;
			},

			/**
			* More Link is initially hidden and browser is unable to calculate width of hidden elements correctly
			* set more link item as visible for a moment offscreen to get width
			* @return {Number} Width of more menu item
			*/
			getMoreLinkWidth: function() {
				var self = this,
				moreElement = self.$moreL1,
				moreLinkWidth;

				if(moreElement.hasClass('hide')) {
					moreElement.css('left','-900000px').removeClass('hide');
					moreLinkWidth = moreElement.outerWidth(true);
					moreElement.css('left','').addClass('hide');
				} else {
					moreLinkWidth = moreElement.outerWidth(true);
				}

				return moreLinkWidth;
			},

			/**
			 * Calculates the currently available space
			 * for L1 items in the main nav, subtracing out
			 * the necessary space for the "More" menu
			 **/
			getAvailableSpace: function() {
				var self = this,
					total = self.$element.outerWidth(),
					borderLeft = parseInt(self.$element.css('border-left-width')) || 0,
					borderRight = parseInt(self.$element.css('border-right-width')) || 0,
					borders = borderLeft + borderRight,
					paddings = parseInt(self.$element.css('padding-left')) + parseInt(self.$element.css('padding-right')),
					margins = parseInt(self.$element.css('margin-left')) + parseInt(self.$element.css('margin-right')),
					l1width = self.getMoreLinkWidth();

				return total - borders - paddings - margins - l1width;
			},

			/**
			 * Calculates the needed space to display
			 * all the current L1 menu items
			 **/
			getNecessarySpace: function() {
				var self = this,
					navWidth = 0;

				// Step through the visible items to calculate
				// the necessary space to show all
				$(self.config.menuItemsSelector,self.$element).each(function() {
					var cachedWidth = $(this).data('width');
					if(cachedWidth) {
						navWidth += cachedWidth;
					} else {
						navWidth += $(this).outerWidth(true);
					}
				});

				return navWidth;
			},

			/**
			 * Retrieves the first item in the more menu
			 * @return JQuery element
			 **/
			_getFirstMoreElement: function() {
				var self = this;
				return $('li',self.$moreMenu).first();
			},

			/**
			 * Retrieves the lastmost item in the main menu before the More menu
			 * @return JQuery element
			 **/
			_getLastMainElement: function() {
				var self = this;
				return $(self.config.menuItemsSelector,self.$element).last();
			},

			/**
			 * Map global namespace method to a local one
			 **/
			_getScreenSize: function() {
				return screenSize.size();
			},

			// calculate and store the width of utility nav on large screens
			getUtilityNavSize: function() {
				var self = this;
				
				if(self._getScreenSize() === "large") {
					var width = 0;
				
					// get the sum width of each visbile <li>
					self.$utilityNav.find('li:visible').each(function() {
						width += $(this).outerWidth(true);
					});

					// include any side padding on the <ul>
					width = width += parseInt(self.$utilityNav.css('padding-right'));
					width = width += parseInt(self.$utilityNav.css('padding-left'));

					// cache the size of the utility nav
					self.utilityNavSize = {
						height: self.$utilityNav.outerHeight(true),
						width : width
					};

					// cache the size of the logo
					self.logoSize = {
						height: $('.topnav-logo').outerHeight(),
						width : $('.topnav-logo').outerWidth()
					};

					// cache the size of the topnav
					self.topnavHeight = $('.topnav-header').outerHeight(true);
				}
			},

			// if utility nav is wider then window, add class to hide the link text
			updateUtilityDisplay: function() {
				var self = this,
					maxWidth = $(window).width();

				if(!self.utilityNavSize) {
					self.getUtilityNavSize();
				}

				// Reduce max width by the width of the logo if utility nav overlaps logo
				if(self.logoSize && self.utilityNavSize && self.logoSize.height > (self.topnavHeight - self.utilityNavSize.height)) {
					maxWidth = maxWidth - self.logoSize.width;
				}
				
				if(self._getScreenSize() === "large" && (maxWidth < self.utilityNavSize.width )) {
					self.$utilityNav.addClass(self.config.hideTextClass);
				}
				else {
					self.$utilityNav.removeClass(self.config.hideTextClass);
				}
			},

			/**
			 * Redraws the L1 contents of the main nav
			 * to show only what can fit in the available space
			 **/
			updateMainMenuItems: function(breakpoint) {
				var self = this,
					navWidth = self.getNecessarySpace(),
					availableSpace = self.getAvailableSpace(),
					$lastMainElement,
					$firstMoreElement;

				// Get screensize only once per resize recursive loop
				breakpoint = breakpoint || self._getScreenSize();

				// On small screens, recursively move everything out of the more menu
				if(self.config.excludeBreakpoints.indexOf(breakpoint) >= 0) {
					// Check if there's any items in the More menu
					$firstMoreElement = self._getFirstMoreElement();

					// Move the first item back to the Main Menu if it will fit onscreen
					if($firstMoreElement.length > 0) {
						self.insertIntoMainMenu($firstMoreElement);
						// Recursively run again for any additional items
						self.updateMainMenuItems(breakpoint);
					}
				} else {

					// Move the last item that doesn't fit into the More menu
					if(navWidth > availableSpace) {
						// Find the last item
						$lastMainElement = self._getLastMainElement();

						if($lastMainElement.length > 0) {
							// cache the display width of the item before popping it
							// out because we can't calculate its dimensions while
							// hidden under the more menu
							$lastMainElement.attr('data-width', $lastMainElement.outerWidth(true));

							// Move the last item into the More menu
							self.insertIntoMoreMenu($lastMainElement);

							// Recursively run again for any additional items that don't fit
							self.updateMainMenuItems(breakpoint);
						}

					} else {
						// Check if there's any items in the More menu
						$firstMoreElement = self._getFirstMoreElement();

						// Move the first item back to the Main Menu if it will fit onscreen
						if(navWidth + $firstMoreElement.data('width') < availableSpace) {
							self.insertIntoMainMenu($firstMoreElement);
							// Recursively run again for any additional items that will fit
							self.updateMainMenuItems(breakpoint);
						}
					}
				}

				// Refresh whether the more menu should be shown or not
				self.toggleMoreMenu();

				// Publish event notifying other plugins the More Dropdown has updated
				$.pubsub('publish','vfdp.aem.topnav.moreMenu.updated');
			},

			/**
			 * Inserts a menu item into the More Menu.
			 * Item will be first in the list
			 * @param JQuery element
			 **/
			insertIntoMoreMenu: function($el) {
				var self = this;

				$el.prependTo(self.$moreMenu);

				// unbind events as they are inserted into the more menu
				if($el.hasClass('topnav-list')){
					$.pubsub('publish','vfdp.aem.topnav.moreMenu.add.list', $el);
				}
				else {
					$.pubsub('publish','vfdp.aem.topnav.moreMenu.add.dropdown', $el);
				}
			},

			/**
			 * Inserts a menu item into the Main Mainu.
			 * Item will be last in menu before "More"
			 * @param JQuery element
			 **/
			insertIntoMainMenu: function($el) {
				var self = this;

				$el.insertBefore(self.$moreL1);

				// rebind dropdown events as they are removed from more menu
				if($el.hasClass('topnav-list')){
					$.pubsub('publish','vfdp.aem.topnav.moreMenu.remove.list', $el);
				}
				else {
					$.pubsub('publish','vfdp.aem.topnav.moreMenu.remove.dropdown', $el);
				}
			},

			/**
			 * Show/hide the more menu depending on whether it has any entries
			 **/
			toggleMoreMenu: function() {
				var self = this;

				if($('li',self.$moreMenu).length > 0) {
					self.$moreL1.removeClass('hide').addClass(self.config.hasChildrenClassName);
				} else {
					self.$moreL1.addClass('hide').removeClass(self.config.hasChildrenClassName);
				}
			},

			/**
			 * Setup events that update main menu
			 **/
			events: function() {
				var self = this;

				// Update display of utility nav and L1/More links when user resizes
				$.pubsub('subscribe', 'window.resize', function(event,data) {
					var breakpoint = (data) ? data.now : undefined;

					// get size of utility nav when switching to large screens for first time
					if(breakpoint === "large" && !self.utilityNavSize) {
						self.getUtilityNavSize();
					}

					// update utility nav display
					self.updateUtilityDisplay();

					// update main menu display
					self.updateMainMenuItems(breakpoint);
				});

				// size the menu items onece the dropdown plugin has loaded
				$.pubsub('subscribe','vfdp.aem.topnav.dropdown.loaded', function(event,data) {
					// Do the first sizing
					self.updateMainMenuItems();
				});

				// Update display of L1 and More when fonts load since they can change the available dimensions
				$.pubsub('subscribe', 'vfdp.fonts.loaded', function(event,data) {
					var breakpoint = (data) ? data.now : undefined;

					// get size of utility nav
					self.getUtilityNavSize();

					// update utility nav display
					self.updateUtilityDisplay();

					// update main menu display
					self.updateMainMenuItems(breakpoint);
				});

				// update display of L1 and more when sticky state minimizes and available space changes
				$.pubsub('subscribe', 'vfdp.topnav.sticky', function(event,data) {
					var breakpoint = (data) ? data.now : undefined;
					self.updateMainMenuItems(breakpoint);
				});
			}
		};

		return mainNav.init();

	})();

	return mainNav;
});
